import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The ComparadorBuyingModalities component.
 */
const ComparadorBuyingModalities = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Comparador-MecanismosDeCompra.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Corresponde al nombre de cada mecanismo de compra que utilizan los organismos compradores.</Item>
        <Item>Monto total transado mediante el mecanismo de compra correspondiente.</Item>
        <Item>Eje correspondiente al tipo de distribución seleccionado</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default ComparadorBuyingModalities
